"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
query getSharingTickets($sharingId: String, $orderId:String) {
  getSharingTickets(sharingId: $sharingId,orderId:$orderId ) {
    email
    phoneNumber
  }
}
`;
exports.default = query;
//# sourceMappingURL=getTicketSharing.query.js.map